class MeowcartLoyaltyMessage {
	constructor() {
		this.currentLang = 'EN';
	}

	errorNumber() {
		const LOYALTY_MSG = {
			400: {
				message: 'Unexpected error.',
			},
			600: {
				message:
					'The PIN cannot be repeated numbers (e.g. 999999) or consecutive numbers (e.g. 123456)',
			},
			601: { message: 'PIN code does not match' },
			602: {
				message:
					'The PIN code contains only numbers, does not contain letters or special characters',
			},
			603: {
				message: 'The answer can not be the same as question',
			},
			604: {
				message: 'Please select a security question',
			},
			99991: { message: 'External server error' },
			999: { message: 'Unexpected error' },
			1001: { message: 'Missing parameters' },
			101: { message: 'Invalid email' },
			102: { message: 'Invalid full name' },
			103: { message: 'Invalid phone number' },
			104: { message: 'Account already exists' },
			106: { message: 'Account already verified' },
			107: { message: 'Account exists and is over 365 days old' },
			108: { message: 'PIN code must be 6 digits' },
			109: { message: 'Invalid security question and answer' },
			110: { message: 'OTP has been sent' },
			201: { message: 'Account successfully created' },
			202: { message: 'Shopify account not found' },
			203: { message: 'Account successfully verified' },
			204: { message: 'Successfully signed in' },
			205: { message: 'Recovery email has been sent' },
			900: { message: 'OTP usage restricted' },
			901: { message: 'OTP is incorrect' },
			902: { message: 'OTP is invalid' },
			9201: { message: 'Email already exists in The1 system' },
			903: { message: 'PIN is invalid' },
			904: { message: 'PIN code is incorrect' },
			905: { message: 'Registration code is invalid' },
			906: { message: 'Registration code not found' },
			907: { message: 'Email hasn\'t been confirmed' },
			9071: { message: 'An error occurred while sending the OTP to your email' },
      9072: { message: 'Please wait before requesting a new OTP' },
			908: { message: 'Recovery is restricted' },
			909: { message: 'Your question or answer is incorrect.' },
			910: {
				message:
					'Recovery through security question & answer successful',
			},
			911: { message: 'Account has been locked out' },
			912: { message: 'Invalid name' },
			913: { message: 'Invalid date of birth' },
			914: { message: 'Invalid address' },
			915: { message: 'Invalid gender' },
			916: { message: 'Invalid security code' },
			917: { message: 'Invalid PIN' },
			918: { message: 'Invalid reset token' },
			919: {
				message: 'New email must be different from the current email',
			},
			920: { message: 'Email already exists in Crocs system' },
			921: { message: 'Invalid OTP' },
			922: { message: 'Invalid old email' },
			923: {
				message: 'New phone must be different from the current phone',
			},
			924: { message: 'Account with this phone is existing' },
			925: { message: 'Invalid coupon token' },
			926: { message: 'Invalid account ID' },
			927: { message: 'Invalid point' },
			928: { message: 'The accumulated points are not enough' },
			929: { message: 'PIN is incorrect' },
			930: { message: 'Invalid old pin' },
			931: { message: 'Invalid new pin' },
			932: { message: 'Password incorrect' },
			933: {
				message: 'New pin must be different from the current pin',
			},
			934: { message: 'Missing security question or answer' },
			936: { message: 'Email recovery failed. You are limited to 3 recovery requests within a 15-minute period.' },
      937: { message: 'Invalid account.' },
      938: { message: 'Action is unauthorized.' },
      939: { message: 'Failed to create customer.' },
      940: { message: 'Resource not found.' },
      941: { message: 'Invalid request format.' },
      942: { message: 'Service provider error.' },
      943: { message: 'Failed to update security question.' },
      944: { message: 'Failed to send message.' },
      945: { message: 'Invalid access token.' },
      946: { message: 'Invalid template.' },
      947: { message: 'Invalid input.' },
      948: { message: 'Invalid request method.' },
      949: { message: 'Data exceeds maximum allowed length.' },
      950: { message: 'Template is missing required parameters.' },
      951: { message: 'Zalo account does not exist.' },
      952: { message: 'Zalo message is not available.' },
      953: { message: 'Validation error.' },
      954: { message: 'Account temporary hold.' },
      955: { message: 'Account under 365 days.' },
      956: { message: 'Your session has expired. Please log in again.' },
			2001: { message: 'Profile updated successfully' },
			2002: { message: 'PIN reset successfully' },
			2003: { message: 'Email change request sent successfully' },
			2004: { message: 'Email changed successfully' },
			2005: { message: 'OTP sent successfully' },
			2006: { message: 'Phone changed successfully' },
			2007: { message: 'Password changed successfully' },
			2008: { message: 'Security question changed successfully' },
			801: { message: 'Invalid campaign' },
			802: { message: 'Voucher collected successfully' },
			1101: { message: 'Insufficient funds' },
			1102: { message: 'Campaign expired' },
			1103: {
				message: 'The limit has been reached and can be exchanged',
			},
      1104: { message: 'Active account limit reached' },
      1105: { message: 'Account limit reached' },
      1106: { message: 'Campaign inactive' },
      1107: { message: 'Campaign issuance limit reached' },
      1108: { message: 'Campaign limit per period reached' },
      1109: { message: 'Campaign pending' },
      1110: { message: 'Campaign removed' },
      1111: { message: 'Campaign stopped' },
      1112: { message: 'Campaign suspended' },
      1113: { message: 'Campaign unknown' },
      1114: { message: 'Campaign expired' },
      1115: { message: 'Invalid start date' },
      1116: { message: 'Voucher cannot be redeemed' },
      1117: { message: 'Voucher cancelled' },
      1118: { message: 'Voucher invalid' },
      1119: { message: 'Voucher locked' },
      1120: { message: 'Voucher already redeemed' },
      1121: { message: 'No vouchers available for this campaign' },
      1122: { message: 'No vouchers available to redeem for campaign' },
      1123: { message: 'No vouchers available to redeem for this identity' },
      1124: { message: 'Voucher expired' },
			1201: {
				message:
					'Invalid operation, before and after cannot be used together',
			},
			1001: { message: 'Invalid point' },
			1002: { message: 'Invalid session' },
			1003: { message: 'Insufficient points' },
			1004: { message: 'Invalid discount code' },
		};

		return LOYALTY_MSG;
	}

	loginOtpModal() {
		return {
			no_otp: 'Haven\'t received the code?',
			request: 'Get new OTP code',
			change_method: 'Change OTP delivery method',
			desc_otp: 'The OTP code is valid within 3 minutes.',
			receive_after: 'Get the new code after',
			desc_with_phone: 'To verify your phone number, please enter the 6-digit OTP code sent to the number',
			change: 'Change',
			desc: 'You are registering, please enter OTP to verify your phone number',
			otp_expired: 'OTP code has expired. Please request a new code.',
			not_correct: 'OTP code is incorrect',
			text: 'You have',
			attempt: 'tries left',
      pin_modal: 'Enter PIN Code',
      pin_modal_desc2: 'Please enter your current PIN for authentication'
		};
	}

	securityModal() {
		return {
			select_question: 'Choose a question'
		};
	}

	errorMessage() {
		return {
			you_have: 'You have',
			attempt_left: 'attempts left'
		};
	}

	emailRecover() {
		return {
			desc_success_1: 'An account recovery link will be sent to your email',
			desc_success_2: 'if you have previously verified your email address. Please check your inbox and click the provided link to reset your PIN.'
		};
	}

	profileUpdate() {
		return {
			select_year: 'Select Year',
			err_dob_format: 'Your date of birth is not valid. Please try again',
			err_field_dob_format: 'Wrong date of birth\'s format ',
			after: 'after',
      update_info_error_dob: 'Date of birth, Month of birth, Year of birth',
      update_info_error_address: 'Address',
      update_info_error_gender: 'Gender',
		};
	}

	addressSelect() {
		return {
			province: 'Select province / city',
			district: 'Select your district',
			ward: 'Select your ward / commune'
		};
	}

	voucherCard() {
		return {
			voucher_detail_online_at_store: 'At the store and ',
			voucher_detail_online: 'Crocs.com.vn',
			apply_button: 'Apply',
			usage_channels: 'Applicable:',
			show_QR: 'Show QR',
			voucher_detail_at_store: 'At the stores',
			no_voucher: 'There are no coupons yet.',
			voucher_online_at_store: 'Online & At Store',
			voucher_online: 'Online',
			voucher_at_store: 'At Store',
			voucher_card_btn_exchange: 'Exchange',
			voucher_card_btn_collect: 'Collect',
			voucher_card_exchange_before: 'Exchange before:',
			voucher_card_collect_before: 'Collect before:',
			online_button: 'Online',
			store_button: 'At Store',
			the1: 'The 1',
			store_voucher: 'Crocs',
			asc: 'Nearest expiration date',
			desc: 'Newest',
      exchange_before: 'Exchange before:',
      voucher_card_confirm_exchange: 'Confirm Exchange',
      voucher_card_confirm_collect: 'Confirm Collect'
		};
	}

	voucher() {
		return {
			discount_detail: 'Offer details',
			discount_condition: 'Conditions of use',
			scan_qr_at_store: 'Scan the code at store',
			discount_title: 'Discount code',
			at_store: 'At store',
			at_online: 'At Crocs.com.vn',
			discount_code_details: 'Discount code details',
			expiration_date: 'Exp. date',
      expiry: 'EXP',
			open_details: 'View details',
			open_qr_code: 'View QR',
			used: 'Used',
			out_of_date: 'Out of date',
			discount_title_single: 'Reduced',
			expiration_date_label: 'Expired',
			terms_conditions: 'Terms & Conditions',
			in_use: 'In use',
			use: 'Use',
			applied: 'Applied',
			point: 'points',
			point_free: 'Free',
			back_btn: 'Cancel',
			view_wallet: 'View wallet',
			view_details: 'View details',
      over: 'Over',
      exchange_success: 'Redemption successful',
      discount_date: 'Promotion valid until',
      collected_success: 'Successfully collected',
      discount_voucher: 'Discount voucher worth',
      at_central_retail: 'at Central Retail Vietnam stores'
		};
	}

	cart() {
		return {
			can_not_apply: 'can not apply',
			apply_success: 'apply successfully',
      remove: 'Remove'
		};
	}

	customToast() {
		return {
			change_security_question_success: 'Security question changed successfully',
			change_pin_success: 'Changed PIN successfully',
			cart_over_5: 'Cannot apply more than 5 discount codes',
			exchange_point_error: 'An error occurred during point conversion. Please try again later!',
			exchange_point_success: 'Points redeemed successfully. Please apply them at the checkout page.',
      update_info_success: 'Update profile successfully',
      invalid_address: 'Address is invalid',
      redeem_voucher_error: 'An error occurred while saving the Voucher!',
      delete_shipping_address_success: 'Shipping address deleted successfully',
      update_shipping_address_success: 'Shipping address updated successfully'
		};
	}

	message() {
		return {
			error: 'An error occurred',
			no_tcs: 'No terms and condition',
			no_description: 'No description',
			invalid_phone_number: 'Invalid phone number',
			icon_type_not_found: 'Icon type not found',
			undefined_error: 'Undefined error',
			discount_from_momo: 'Get up to 200,000 VND off on products from 2 million VND when paying via MoMo wallet.',
			field_error: 'Missing information',
			yes_change_label: 'Yes',
			cancel_change_label: 'Cancel',
			failed_load_list_voucher: 'Failed to load the list of vouchers.',
			no_title: 'No title',
			no_information_available: 'No information available',
			invalid_date: 'The date is not valid',
			voucher_not_found: 'Voucher not found',
      not_enough_point: 'Not enough points to redeem',
      be_a_number: 'The numbet of points to redeem must be a number',
      exchange_point: 'Exchange accumulated points',
      shopping_point: 'Shopping points',
      product_review: 'Product review',
      loyalty_point: 'point',
      unexpected_error: 'Unexpected error'
		};
	}

	exchangePoint() {
		return {
			desc: 'You have',
			desc1: 'accumulated points.',
			desc2: 'Use up to',
			to_order: 'Redeem points to use for this order (1 point = 1 VND)',
			error_convert: 'The number of points converted must be a multiple of 1000',
			error_over: 'Your existing points are not enough to make the conversion',
			error_min: 'The minimum point requirement for conversion is 10,000',
			btn: 'Exchange',
			exchange: 'Number of exchanged points',
			over_100: 'Orders from 100,000 VND',
			back_to_account: 'Update now',
			expired_points_notice: 'points will expire on',
      exchange_point_desc: 'You have',
      exchange_point_desc2: 'Use up to',
		};
	}

	lockedModal() {
		return {
			title: 'Temporary Lock',
			desc_change_limit_pin_submit: 'Your account has been temporarily locked due to entering the wrong PIN 3 times.',
			try_again_after: 'Please try again after',
      desc_input_otp_wrong: 'Your account has been temporarily locked due to entering the wrong OTP code 3 times.',
      desc_change_limit_otp_request: 'Your account has been temporarily locked due to requesting the OTP code 3 times.',
      request_otp_opt_3_times_title: 'Reached OTP sending limit',
      request_email_opt_3_times: 'You have requested the email OTP 3 times. Please try again later.',
      title_email_request: 'Reached OTP sending limit',
      desc_email_request: 'You can only request 3 OTP sends within 15 minutes.',
      desc_locked: 'Your account has been temporarily locked.'
		};
	}

	updateEmailModal() {
		return {
			not_receive: "Haven't received the code?",
			receive_after: 'Get a new code',
			desc_otp: 'OTP code is valid for 3 minutes.',
			desc: 'To verify, please enter the 6-digit OTP code sent to',
			desc_verify_email: 'to complete your profile update.'
		};
	}

	updateEmailSuccessModal() {
		return {
			title: 'Email updated successfully',
			desc: 'Your email has been changed. Please login again to continue.'
		};
	}

	changeModal() {
		return {
			continue_text: 'Continue',
			cancle_text: 'Cancel',
			change_text: 'Confirm'
		};
	}

	changeEmailModal() {
		return {
			verify_email_title: 'Email Authentication',
			change_email_title: 'Change Email',
			verify_email_desc: 'Please enter your PIN to continue verifying email information.',
			change_email_desc: 'Please enter your PIN to continue changing your email information',
      change_email_label: 'Email Address',
      change_email_placeholder: 'Enter your email address'
		};
	}

	changePhoneModal() {
		return {
			change_phone_title: 'Change phone number',
      change_phone_desc: 'Please enter your current PIN to continue changing phone number.',
			change_phone_label: 'Phone number',
			change_phone_placeholder: 'Enter your phone number'
		};
	}

	updatePhoneModal() {
		return {
			desc: 'We just sent a 6-digit verification code to the phone number'
		};
	}

  updatePhoneSuccessModal() {
		return {
			title: 'Update phone number successfully',
			desc: 'Your phone number has been changed. Please login again.'
		};
	}

	otpModal() {
		return {
			title: 'OTP Verification',
			desc: 'An OTP code has been sent to your phone number',
			resend: 'Resend code',
			expired: 'OTP code has expired',
			invalid: 'Invalid OTP code',
			otp_expired: 'OTP code has expired. Please resend a new code.',
			pin_modal_title: 'Enter PIN code',
			pin_modal_label: 'Enter your current PIN',
			pin_input_label: 'Enter your PIN',
			forgot_pin: 'Forgot PIN?',
			not_correct: 'Incorrect OTP code',
			text: 'You have',
			attempt: 'attempts left',
      pin_modal_desc: 'Please enter your 6-digit PIN to verify'
		};
	}

	securityQuestionModal() {
		return {
			label_question: 'Security Question',
			label_answer: 'Answer',
			placeholder: 'Enter your answer',
			warning: 'Note:',
			desc: 'Select a new security question and answer',
      note: 'Answer cannot be the same as the question',
			not_blank: 'This field cannot be left blank'
		};
	}

	configPinModal() {
		return {
      pin_modal_title: 'Change PIN',
      pin_modal_label: 'Enter your new PIN',
			label_pin: 'Enter the 6-digit PIN',
			label_confirm_pin: 'Re-enter the PIN'
		};
	}

	continueBtn() {
		return 'Continue';
	}

  customModal() {
    return {
      title_not_update_profile: 'Information update require',
      desc_not_update_profile: 'To use the redemption and voucher collection feature, you need to provide complete personal information!',
      title_not_enough: 'Not enough redemption points'
    }
  }
}
